export const openLink = (link: string, fileName?: string) => {
  const anchorLink = window.document.createElement('a');
  anchorLink.href = link;
  anchorLink.target = '_blank';
  if (fileName) anchorLink.download = fileName;
  window.document.body.appendChild(anchorLink);
  anchorLink.click();
  window.document.body.removeChild(anchorLink);
};

export const openAsyncLink = async (
  getLink: () => Promise<string | undefined>,
  fileName?: string
) => {
  const win = window.open('', '_blank');
  const link = await getLink();
  if (link) {
    if (win) {
      win.location.href = link;
      win.focus();
    } else {
      openLink(link, fileName);
    }
  }
};
